export default () => ({
    hasLong: false,
    opened: false,

    init() {
        this.hasLong = this.$refs.long.textContent.length > this.$refs.short.textContent.length;
    },
})